<app-link-account></app-link-account>
@if (!hasLinkedAccount) {
  <div class="alert alert-warning alert-dismissible fade show" role="alert">
    <strong>Verbinde deinen Patreon oder Youtube Account!</strong> Und erhalte Zugang zum gewerteten Tippspiel:
    <a class="alert-link clickable" (click)="linkAccount()">Jetzt Account verbinden.</a>
  </div>
}
